"use client";

import { Fragment, useMemo } from "react";
import Image from "next/image";
import AutoScroll from "embla-carousel-auto-scroll";
import { Carousel, CarouselContent, CarouselItem } from "@/shadcn/ui/carousel";
import { TrustpilotMini } from "@/components/global/TrustpilotWidgets";
import phemex from "@/public/home/trust-logos/phemex.png";
import tuv from "@/public/home/trust-logos/tuv.png";
import compare from "@/public/home/trust-logos/compare.png";

export default function TrustLogos({ className = "", language }: { className?: string; language?: string }) {
  const autoScroll = useMemo(() => AutoScroll({ speed: 1, startDelay: 0, stopOnInteraction: false }), []);

  const logos = [
    <Image
      className="h-[7.7rem] w-[15.138rem] lg:h-[11rem] lg:w-[21.625rem]"
      quality={100}
      alt="Phemex – $10 Million+ in Institutional Capital"
      src={phemex}
    />,
    <div className="-mb-[4rem] w-[16rem] lg:w-[min(25rem,100%)]">
      <TrustpilotMini
        locale={language === "de" ? "de-DE" : "en-US"}
        theme="light"
      />
    </div>,
    <Image
      className="h-[6.65rem] w-[17.763rem] lg:h-[9.5rem] lg:w-[25.375rem]"
      quality={100}
      alt="TÜV Rheinland"
      src={tuv}
    />,
    <a
      href="https://propfirm.compare/propfirm/iq-capital"
      target="_blank"
      rel="noopener noreferrer">
      <Image
        className="h-[7.963rem] w-[12.338rem] lg:h-[11.375rem] lg:w-[17.625rem]"
        quality={100}
        alt="Prop Firm Compare"
        src={compare}
      />
    </a>,
  ];

  return (
    <div className={`relative w-full lg:w-[120rem] ${className}`}>
      <div className="hidden items-center justify-between gap-[5rem] lg:flex">
        {logos.map((logo, i) => (
          <Fragment key={i}>
            {i > 0 && <div className="h-[10rem] w-px bg-black/10"></div>}
            {logo}
          </Fragment>
        ))}
      </div>

      <Carousel
        opts={{ loop: true, dragFree: true }}
        plugins={[autoScroll]}
        className="w-full lg:hidden">
        <CarouselContent className="-ml-[6rem] items-center">
          {[...logos, ...logos, ...logos].map((logo, i) => (
            <CarouselItem
              key={i}
              className="basis-auto pl-[6rem]">
              {logo}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
}
